module.exports = __webpack_public_path__ + "img/sirca.45a13589.jpg";